import { defineTokens } from "@chakra-ui/react"

export const colors = defineTokens.colors({
  primary: {
    DEFAULT: {
      value: "#581FE6",
    },
    50: {
      value: "#EEE9FD",
    },
    100: {
      value: "#DED2FA",
    },
    200: {
      value: "#BCA5F5",
    },
    300: {
      value: "#9B79F0",
    },
    400: {
      value: "#794CEB",
    },
    500: {
      value: "#581FE6",
    },
    600: {
      value: "#4619B8",
    },
    700: {
      value: "#35138A",
    },
    800: {
      value: "#230C5C",
    },
    900: {
      value: "#12062E",
    },
    950: {
      value: "#12062E",
    },
  },
  secondary: {
    DEFAULT: {
      value: "#FF6701",
    },
    50: {
      value: "#FFF0E6", // Very light orange tint
    },
    100: {
      value: "#FFE0CC", // Light orange tint
    },
    200: {
      value: "#FFC299", // Soft orange tint
    },
    300: {
      value: "#FFA366", // Medium light orange
    },
    400: {
      value: "#FF8533", // Light orange
    },
    500: {
      value: "#FF6701", // Base orange
    },
    600: {
      value: "#CC5201", // Slightly darker
    },
    700: {
      value: "#993E01", // Darker orange
    },
    800: {
      value: "#662900", // Deep orange
    },
    900: {
      value: "#331500", // Very deep orange
    },
    950: {
      value: "#1A0A00", // Darkest orange
    },
  },
  tertiary: {
    DEFAULT: {
      value: "#F61067",
    },
    50: {
      value: "#FEF2F4",
    },
    100: {
      value: "#FDE4E9",
    },
    200: {
      value: "#FBC6D0",
    },
    300: {
      value: "#FAA2B4",
    },
    400: {
      value: "#F87393",
    },
    500: {
      value: "#F61067",
    },
    600: {
      value: "#DC0E5C",
    },
    700: {
      value: "#BF0C50",
    },
    800: {
      value: "#9C0A41",
    },
    900: {
      value: "#6E072E",
    },
    950: {
      value: "#580522",
    },
  },
  transparent: {
    value: "transparent",
  },
  current: {
    value: "currentColor",
  },
  black: {
    value: "#09090B",
  },
  white: {
    value: "#FFFFFF",
  },
  whiteAlpha: {
    50: {
      value: "rgba(255, 255, 255, 0.04)",
    },
    100: {
      value: "rgba(255, 255, 255, 0.06)",
    },
    200: {
      value: "rgba(255, 255, 255, 0.08)",
    },
    300: {
      value: "rgba(255, 255, 255, 0.16)",
    },
    400: {
      value: "rgba(255, 255, 255, 0.24)",
    },
    500: {
      value: "rgba(255, 255, 255, 0.36)",
    },
    600: {
      value: "rgba(255, 255, 255, 0.48)",
    },
    700: {
      value: "rgba(255, 255, 255, 0.64)",
    },
    800: {
      value: "rgba(255, 255, 255, 0.80)",
    },
    900: {
      value: "rgba(255, 255, 255, 0.92)",
    },
    950: {
      value: "rgba(255, 255, 255, 0.95)",
    },
  },
  blackAlpha: {
    50: {
      value: "rgba(0, 0, 0, 0.04)",
    },
    100: {
      value: "rgba(0, 0, 0, 0.06)",
    },
    200: {
      value: "rgba(0, 0, 0, 0.08)",
    },
    300: {
      value: "rgba(0, 0, 0, 0.16)",
    },
    400: {
      value: "rgba(0, 0, 0, 0.24)",
    },
    500: {
      value: "rgba(0, 0, 0, 0.36)",
    },
    600: {
      value: "rgba(0, 0, 0, 0.48)",
    },
    700: {
      value: "rgba(0, 0, 0, 0.64)",
    },
    800: {
      value: "rgba(0, 0, 0, 0.80)",
    },
    900: {
      value: "rgba(0, 0, 0, 0.92)",
    },
    950: {
      value: "rgba(0, 0, 0, 0.95)",
    },
  },
  gray: {
    50: {
      value: "#F9FAFB",
    },
    100: {
      value: "#F2F4F7",
    },
    200: {
      value: "#EAECF0",
    },
    300: {
      value: "#D0D5DD",
    },
    400: {
      value: "#98A1B2",
    },
    500: {
      value: "#667085",
    },
    600: {
      value: "#475467",
    },
    700: {
      value: "#344054",
    },
    800: {
      value: "#1D2939",
    },
    900: {
      value: "#101828",
    },
    950: {
      value: "#0D131F",
    },
  },
  red: {
    50: {
      value: "#FEF3F2",
    },
    100: {
      value: "#FEE4E2",
    },
    200: {
      value: "#FECDCA",
    },
    300: {
      value: "#FCA19B",
    },
    400: {
      value: "#F97066",
    },
    500: {
      value: "#F04437",
    },
    600: {
      value: "#D92C20",
    },
    700: {
      value: "#B42318",
    },
    800: {
      value: "#8E1604",
    },
    900: {
      value: "#7F1304",
    },
    950: {
      value: "#721103",
    },
  },
  orange: {
    50: {
      value: "#fff7ed",
    },
    100: {
      value: "#ffedd5",
    },
    200: {
      value: "#fed7aa",
    },
    300: {
      value: "#fdba74",
    },
    400: {
      value: "#fb923c",
    },
    500: {
      value: "#f97316",
    },
    600: {
      value: "#ea580c",
    },
    700: {
      value: "#92310a",
    },
    800: {
      value: "#6c2710",
    },
    900: {
      value: "#3b1106",
    },
    950: {
      value: "#220a04",
    },
  },
  yellow: {
    50: {
      value: "#fefce8",
    },
    100: {
      value: "#fef9c3",
    },
    200: {
      value: "#fef08a",
    },
    300: {
      value: "#fde047",
    },
    400: {
      value: "#facc15",
    },
    500: {
      value: "#eab308",
    },
    600: {
      value: "#ca8a04",
    },
    700: {
      value: "#845209",
    },
    800: {
      value: "#713f12",
    },
    900: {
      value: "#422006",
    },
    950: {
      value: "#281304",
    },
  },
  green: {
    50: {
      value: "#ECFDF3",
    },
    100: {
      value: "#D1FADF",
    },
    200: {
      value: "#A6F4C5",
    },
    300: {
      value: "#6BE9A6",
    },
    400: {
      value: "#31D583",
    },
    500: {
      value: "#12B669",
    },
    600: {
      value: "#039754",
    },
    700: {
      value: "#027A48",
    },
    800: {
      value: "#055F3A",
    },
    900: {
      value: "#054E31",
    },
    950: {
      value: "#044629",
    },
  },
  teal: {
    50: {
      value: "#f0fdfa",
    },
    100: {
      value: "#ccfbf1",
    },
    200: {
      value: "#99f6e4",
    },
    300: {
      value: "#5eead4",
    },
    400: {
      value: "#2dd4bf",
    },
    500: {
      value: "#14b8a6",
    },
    600: {
      value: "#0d9488",
    },
    700: {
      value: "#0c5d56",
    },
    800: {
      value: "#114240",
    },
    900: {
      value: "#032726",
    },
    950: {
      value: "#021716",
    },
  },
  blue: {
    50: {
      value: "#E2F1FF",
    },
    100: {
      value: "#B6DDFA",
    },
    200: {
      value: "#84BCF0",
    },
    300: {
      value: "#4DA2F0",
    },
    400: {
      value: "#2C87DB",
    },
    500: {
      value: "#1368B7",
    },
    600: {
      value: "#0E5597",
    },
    700: {
      value: "#074075",
    },
    800: {
      value: "#083157",
    },
    900: {
      value: "#01203D",
    },
    950: {
      value: "#011B37",
    },
  },
  cyan: {
    50: {
      value: "#ecfeff",
    },
    100: {
      value: "#cffafe",
    },
    200: {
      value: "#a5f3fc",
    },
    300: {
      value: "#67e8f9",
    },
    400: {
      value: "#22d3ee",
    },
    500: {
      value: "#06b6d4",
    },
    600: {
      value: "#0891b2",
    },
    700: {
      value: "#0c5c72",
    },
    800: {
      value: "#134152",
    },
    900: {
      value: "#072a38",
    },
    950: {
      value: "#051b24",
    },
  },
  purple: {
    50: {
      value: "#faf5ff",
    },
    100: {
      value: "#f3e8ff",
    },
    200: {
      value: "#e9d5ff",
    },
    300: {
      value: "#d8b4fe",
    },
    400: {
      value: "#c084fc",
    },
    500: {
      value: "#a855f7",
    },
    600: {
      value: "#9333ea",
    },
    700: {
      value: "#641ba3",
    },
    800: {
      value: "#4a1772",
    },
    900: {
      value: "#2f0553",
    },
    950: {
      value: "#1a032e",
    },
  },
  pink: {
    50: {
      value: "#fdf2f8",
    },
    100: {
      value: "#fce7f3",
    },
    200: {
      value: "#fbcfe8",
    },
    300: {
      value: "#f9a8d4",
    },
    400: {
      value: "#f472b6",
    },
    500: {
      value: "#ec4899",
    },
    600: {
      value: "#db2777",
    },
    700: {
      value: "#a41752",
    },
    800: {
      value: "#6d0e34",
    },
    900: {
      value: "#45061f",
    },
    950: {
      value: "#2c0514",
    },
  },
  social: {
    behance: {
      value: "#053eff",
    },
    dribbble: {
      value: "#ea4c89",
    },
    linkedin: {
      value: "#0A66C2",
    },
    google: {
      value: "#4285f4",
    },
    x: {
      value: "#14171a",
    },
    twitter: {
      value: "#14171a",
    },
    github: {
      value: "#333",
    },
  },
})
